import { CUSTOMER_VEHICLES_SIDEBAR_MAPPER } from '../constants';

const FORM_KEYS = [
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.vin.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.type.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.mileage.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.plate.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.manufacturer.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.transmission.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.model.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.year.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.edition.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.displacement.key,
  CUSTOMER_VEHICLES_SIDEBAR_MAPPER.fuel.key,
];

const TRANSMISSION_OPTIONS = [
  { text: 'Manual', value: 'manual' },
  { text: 'Automatic', value: 'automatic' },
  { text: 'Semi-Automatic', value: 'semi-Automatic' },
];

const FUEL_OPTIONS = [
  { text: 'Gasoline', value: 'gasoline' },
  { text: 'Diesel', value: 'diesel' },
  { text: 'Electric', value: 'electric' },
  { text: 'Gas', value: 'gas' },
];

export { FORM_KEYS, TRANSMISSION_OPTIONS, FUEL_OPTIONS };
